/**
 * A request can succeed and still need a manual follow-up from the user - the API reports
 * that with HTTP 206 and an error reason describing what to do (e.g. the consent form mail
 * could not be sent, so the link has to be shared with the candidate manually).
 *
 * Those notices are emitted from the fetcher and rendered by <PartialSuccessNotice /> at the
 * app root, because the screen that triggered the request is usually closed on success.
 */

const listeners = new Set();

export const URL_PATTERN = /https?:\/\/[^\s]+/;

/**
 * splits the reason coming from the API into the text and the link it carries, so that the
 * link can be rendered as something the user can copy instead of a long line of text
 * @function parsePartialSuccessMessage
 * @param {string} message
 * @returns {{ text: string, url: string }}
 */
export const parsePartialSuccessMessage = (message = '') => {
  const [match] = String(message).match(URL_PATTERN) || [];
  // trailing punctuation is part of the sentence, not of the link
  const url = (match || '').replace(/[.,;:)\]}]+$/, '');
  const text = url
    ? String(message)
        .replace(match, '')
        .replace(/[:\s]+$/, '')
    : String(message);

  return { text: text.trim(), url };
};

/**
 * @function subscribeToPartialSuccess
 * @param {Function} listener called with every notice
 * @returns unsubscribe function
 */
export const subscribeToPartialSuccess = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * @function showPartialSuccessNotice
 * @param {{ message: string }} notice
 */
export const showPartialSuccessNotice = ({ message } = {}) => {
  if (!message) return;
  listeners.forEach((listener) => listener({ message }));
};
